import { string, array } from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import Player from '../Player/Player'

const Blurb = ({ title, text, videos }) => {
  const [currentVideo, setCurrentVideo] = useState(null);
  const playlistItems = useRef([]);
  const POLICYKEY =
    'BCpkADawqM2ftFB04csX33TqKAU5NFgfbwD6wR13-opWUz27tF87ChCguH4vOc5owXPUlUykZ83kNLsDpRqDOC7zJyR3sLLCEZblfBwX0UXDcqdfYNaOgR1y1Sr5n4uYAD4ZqrmcEYKx-63Q';

  const hashChanged = () => {
    if (window.location.hash) {
      const hash = window.location.hash.split('#')[1]
      const item = playlistItems.current.find((x) => x.id === hash)
      if (item) {
        setCurrentVideo(item)
        console.log('Setting current item to', item)
      }
    }
  }

  const fetchEpisodeDetails = async () => {
    let url =
      'https://edge.api.brightcove.com/playback/v1/accounts/1971571337001/videos?q='
    let qs = videos.map((x) => `id:${x.id}`).join('%20')
    const items = await (
      await fetch(url + qs, {
        headers: {
          accept: 'application/json;pk=' + POLICYKEY,
        },
      })
    ).json()
    if (items) {
      const newItems = videos.map((x) => {
        const videoItem = items.videos.find(i => i.id === x.id);
        if (!videoItem) return;
        return {
          ...x,
          name: x.shortTitle || videoItem.name,
          thumbnail: videoItem.thumbnail,
          duration: videoItem.duration,
        }
      });
      playlistItems.current = newItems;
    }
  }

  useEffect(() => {
    window.addEventListener('hashchange', hashChanged, false);
    console.log('Fetching Episode Details');
    (async () => {
      await fetchEpisodeDetails();
      if (window.location.hash) {
        const hash = window.location.hash.split('#')[1]
        const item = playlistItems.current.find((x) => x.id === hash)
        setCurrentVideo(item || playlistItems.current[0])
      } else {
        setCurrentVideo(playlistItems.current[0])
      }
    })();

    return () => {
      window.removeEventListener('hashchange', hashChanged, false);
    }
  }, []);

  return (
    <div className="dds-o-center" data-layer-region={`episode - ${title}`}>
      <h2 className="dds-c-section-title" data-align="center">
        {title}
      </h2>
      <div className="module-header text-xl">
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
      </div>

      {currentVideo && (
        <Player
          currentVideo={currentVideo}
          playerId="osV0e0rlk"
          playlist={playlistItems.current}
        />
      )}
    </div>
  )
}

Blurb.propTypes = {
  title: string,
  text: string,
  videos: array,
}

export default Blurb
